/* global globalThis */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { PopupTypes } from '../../../components/Popup';
import { T } from '../../../components/Translations';
import { ApiUrl, AppPages, Defines, UserRoles } from '../../../project/Defines';
import { Project } from '../../../project/Project';
import { EVENT_NAME } from '../../../project/utilities';
import ListView from '../../../Shared/ListView';
import { COLUMN_FORMAT, COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { openPopup } from '../../../store/actions';
import moment from 'moment';

/**
 * @exports ServiceCalls
 */
function ServiceCalls(props) {
  const windowKey = 'wndSocietePicker';
  const { dispatch, unassigned, role, canCreateCall, dataItem } = props;
  const isDispatcher = role === UserRoles.DISPATCHER;
  const isCallCenter = role === UserRoles.CALL_CENTER;

  const history = useHistory();
  const _data = { internal_serial_number: dataItem.internal_serial_number };
  const [isMobile, setIsMobile] = useState(globalThis.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(globalThis.innerWidth <= 768);
    };
    
    globalThis.addEventListener('resize', handleResize);
    return () => globalThis.removeEventListener('resize', handleResize);
  }, []);

  const openPicker = useCallback(record => {
    dispatch(openPopup({
      windowKey,
      title: <T>text.assign_subcontractor</T>,
      type: PopupTypes.SocietePicker,
      bodyProps: {
        ...{ ID: record.ID, data: record, isConnectAs: false }
        // updateData: (record) => { updateData(updateSuccessCallback, null, { overrideData: { ID: dataItem.ID, societe_uuid: record.uuid } }) }
      },
      // className: PopupClasses.Large,
      fullScreen: false
    }));
  }, [dispatch]);

  const columns = [
    {
      text: 'text.call_id',
      // noSort: 'true',
      field: 'call_id',
      width: 80,
      fixed: 'left',
      type: COLUMN_TYPE.TEXT,
      linkAppPage: AppPages.ServiceCallsDetails
    },
    {
      text: 'text.subject',
      // noSort: 'true',
      field: 'subject',
      width: 300,
      fixed:(isMobile ? "" : 'left'),
      render: (text, record) => {
        return (
          <wrap title={text}>
            <text light=''>{text}</text>
          </wrap>
        );
      },
      type: COLUMN_TYPE.TEXT
    },
    // {
    //   text: 'text.call_center',
    //   // noSort: 'true',
    //   field: 'call_center',
    //   width: 120,
    //   fixed:(isMobile ? "" : 'left'),
    //   type: COLUMN_TYPE.TEXT
    // },
    {
      text: 'text.status',
      // noSort: 'true',
      field: 'status',
      width: 150,
      fixed:(isMobile ? "" : 'left'),
      render: (text, record) => {
        return (
          <wrap>
            <group compact="">
              <badge outline="">{text}</badge>
            </group>
          </wrap>
        );
      },
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.code_product',
      // noSort: 'true',
      field: 'code_product',
      width: 140,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.internal_sn',
      // noSort: 'true',
      field: 'internal_serial_number',
      width: 120,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.item_name',
      // noSort: 'true',
      field: 'item_name',
      width: 160,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.call_type',
      // noSort: 'true',
      field: 'call_type',
      width: 100,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.problem_type',
      // noSort: 'true',
      field: 'problem_type',
      width: 130,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.zip',
      // noSort: 'true',
      field: 'code_postal',
      width: 60,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.city',
      // noSort: 'true',
      field: 'ville',
      width: 110,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.phone',
      // noSort: 'true',
      field: 'phone',
      width: 120,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.created_date',
      // noSort: 'true',
      field: 'created_at',
      render: (text) => <wrap> <text>{moment.utc(text).local().format(Defines.Format.MomentDateTime)}</text></wrap>,
      width: 140,
      format: COLUMN_FORMAT.DATETIME,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.appointment_date',
      // noSort: 'true',
      field: 'appointment_date_at',
      width: 140,
      format: COLUMN_FORMAT.DATETIME,
      type: COLUMN_TYPE.TEXT
    },
    {
      text: 'text.subcontractor',
      // noSort: 'true',
      field: 'subcontractor_name',
      width: 140,
      type: COLUMN_TYPE.TEXT
    },
    {
      type: COLUMN_TYPE.ACTION,
      fixed: 'right',
      commands: unassigned && [
        { command: 'edit' },
        { command: 'assign', icon: 'wrench', tooltip: "text.assign_manually", onClick: (record) => openPicker(record) }
      ]
    }
  ];

  const onNewServiceCall = () => {
    history.push('/servicecallsdetails/create', { _data });
  };

  return (
    <ListView
      {...props}
      skipNewButton={dataItem.status_id !== "A" || (!(isDispatcher || isCallCenter) && !canCreateCall) || unassigned}
      className={`scroll_fix ${isMobile ? "visible_buttons" : ""}`}
      columnConfig={columns}
      apiUrl={ApiUrl.ServiceCallList}
      detailUrl={Project.getPageUrl(AppPages.ServiceCallsDetails)}
      listUpdateEvent={EVENT_NAME.SERVICE_CALL_LIST_UPDATE}

      staticFilter={{
        unassigned,
        serviceContractProduit_uuid: dataItem?.produit_uuid,
        serviceContract_internalSerialNumber: dataItem?.internal_serial_number
      }}

      onNewClick={onNewServiceCall}
    />
  );
}

ServiceCalls.propTypes = {
    dispatch: PropTypes.func.isRequired,
    unassigned: PropTypes.bool,
    role: PropTypes.string.isRequired,
    canCreateCall: PropTypes.bool.isRequired,
    dataItem: PropTypes.object.isRequired
};

export default connect(state => ({
  role: state.role,
  canCreateCall: state.userData.canCreateCall
}))(ServiceCalls);